// src/lib/tva-garde.js — LE GARDE « ASSUJETTI TVA » (P-2.46, décision Dimitri du 29/10).
//
// L'appli ne sait pas encore facturer en HT / TVA / TTC (P-5.35). Tant que la
// case « Assujetti TVA » des Paramètres est cochée (`cfg.co.tva === true`),
// AUCUNE pièce de la conciergerie ne s'émet : ni facture propriétaire, ni
// avoir, ni facture voyageur. Le refus tombe AVANT tout tirage de numéro.
//
// UNE SEULE PORTE : cette fonction pure. Elle est appelée
//   · côté serveur : lib/invoice-handlers.js (« Émettre » un brouillon,
//     avoir) et lib/piece-voyageur-emettre.js (facture voyageur) ;
//   · côté bouton : src/App.jsx (facture propriétaire, brouillon, avoir) et
//     src/views/logements/FicheDocsCtrl.jsx (facture voyageur).
// Le cron des reçus (api/cron/emit-receipts.js) n'émet QUE des pièces au nom
// du propriétaire (il saute l'émetteur « fbz ») : il n'est pas concerné.
//
// Une pièce au nom du PROPRIÉTAIRE (émetteur 'proprio') ne dépend pas de la
// TVA de la conciergerie : jamais bloquée ici. Tout autre émetteur (« fbz »,
// ou inconnu) est traité comme une pièce de la conciergerie.
//
// Réglages illisibles (cfg absent) pour une pièce de la conciergerie ⇒ refus
// aussi : on ne sait pas si la case est cochée, on n'émet pas.
//
// ⚠️ CommonJS pur, zéro dépendance : l'écran l'importe directement, le
// serveur par le relais lib/tva-garde.js (même schéma que emitter-resolver).

const CODE_REFUS_TVA = "tva_non_prise_en_charge";
const CODE_REFUS_CFG = "tva_reglages_illisibles";

const MESSAGE_REFUS_TVA =
  "La facturation avec TVA n'est pas encore prise en charge : rien n'a été émis. " +
  "Décochez « Assujetti TVA » ou attendez la facturation avec TVA.";

const MESSAGE_REFUS_CFG =
  "Réglages illisibles : impossible de vérifier « Assujetti TVA ». Rien n'a été émis.";

// Le texte gris affiché près de la case, dans les Paramètres.
const AVERTISSEMENT_CASE_TVA =
  "Sans effet sur les montants : la facturation avec TVA n'existe pas encore ; cocher bloque l'émission.";

/** La case « Assujetti TVA » est-elle cochée ? (même lecture stricte que numeroTvaImprimable) */
function tvaCochee(cfg) {
  return !!(cfg && cfg.co && cfg.co.tva === true);
}

/**
 * Le garde. Rend `null` (émission permise) ou `{ code, message }` (refus).
 *
 * @param {object|null} cfg — le blob de réglages (cfg.co.tva)
 * @param {{ emetteur?: string }} [opts] — 'proprio' | 'fbz' | autre
 */
function refusEmissionTva(cfg, opts) {
  const emetteur = opts && opts.emetteur;
  if (emetteur === "proprio") return null;
  if (!cfg || typeof cfg !== "object") {
    return { code: CODE_REFUS_CFG, message: MESSAGE_REFUS_CFG };
  }
  if (tvaCochee(cfg))
    return { code: CODE_REFUS_TVA, message: MESSAGE_REFUS_TVA };
  return null;
}

module.exports = {
  refusEmissionTva,
  tvaCochee,
  CODE_REFUS_TVA,
  CODE_REFUS_CFG,
  MESSAGE_REFUS_TVA,
  MESSAGE_REFUS_CFG,
  AVERTISSEMENT_CASE_TVA,
};
